import {Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {debounceTime} from "rxjs/operators";
import {Subject} from "rxjs";
import {OPTIONS_POSITION} from "../options/options.component";

@Component({
  selector: 'beaconstac-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss']
})
export class FilterDropdownComponent implements OnInit, OnChanges {

  /**
   * Label above filter-dropdown
   */
  @Input()
  label: string;

  /**
   * Filter Dropdown for different types
   */
  @Input()
  filterDropdownType: number = 0;

  /**
   * Placeholder for filter-dropdown
   */
  @Input()
  placeholder: string;

  /**
   * Title for filter-dropdown
   */
  @Input()
  title: string;

  /**
   * custom width for filter-dropdown
   */
  @Input()
  width = '';

  /**
   * value selected in filter-dropdown
   */
  @Input()
  value: any;

  /**
   * content of filter-dropdowm
   */
  @Input()
  listItems = [];

  /**
   * In case specific output is required from custom object
   */
  @Input()
  specificOutput = '';

  /**
   * value event emitter
   */
  @Output()
  valueChange = new EventEmitter<any>();

  /**
   * specific output event emitter
   */
  @Output()
  specificOutputChange = new EventEmitter<any>();

  /**
   * specific output event emitter
   */
  @Output()
  inputChangeEvent = new EventEmitter<any>();

  /**
   * label field from custom object
   */
  @Input()
  optionLabelField: string;

  /**
   * value field from custom object
   */
  @Input()
  optionValueField: string;

  /**
   * is filter-dropdown disabled
   */
  @Input()
  disabled: boolean;

  @Input()
  disableInput: boolean;

  @Input()
  valid: boolean = true;

  @Input()
  errorMessage: string;

  @Input()
  dynamicSearch: boolean;

  @Input()
  optionsType = 1;

  @Input()
  enableInfiniteScrolling = false;

  @Input()
  isFetchingData = false;

  @Input()
  allowEmptySearch = false;

  @Input()
  labelSubText = '';

  @Input()
  optionsHeaderText = '';

  @Input()
  isInputGroup = false;

  @Input()
  maxHeight: string = '200px';

  @Input()
  stickyCTAText: string = 'Sticky Test in mandated in optionTypes 3';

  @Output()
  fetchMoreData: EventEmitter<null> = new EventEmitter();

  @Output()
  stickyCTAClicked: EventEmitter<null> = new EventEmitter();

  filteredListItems = [];

  fixedValues: string[] = [];

  isListOpen = false;

  contentChangeSubject = new Subject();
  toggleSubject = new Subject();
  dropdownOptionsPosition: OPTIONS_POSITION;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const activeDropdown = document.querySelectorAll('.dropdown-options.active');
    const allDropDowns = document.querySelectorAll('.dropdown-toggle');

    if (event.target && !event.target['id'] && activeDropdown.length > 0) {
      activeDropdown[0].classList.remove('active');

      for (let i = 0; i < allDropDowns.length; i++) {
        allDropDowns[i].classList.remove('rotate-caret');
      }
    }
  }

  toggleOptions(_this) {
    this.isListOpen = !this.isListOpen;

    if (this.isListOpen || this.disableInput) {

      setTimeout(() => {
        document.getElementById(_this.title + '-input').focus();
        document.getElementById(_this.title).classList.add('active');
        if (!this.isInViewport(document.getElementById(_this.title))) {
          this.dropdownOptionsPosition = OPTIONS_POSITION.TOP;
        }
      }, 100);
    } else {
      document.getElementById(_this.title).classList.remove('active');
      this.removeDuplicateListValues(this.listItems);
    }

  }

  filterList(value) {
    this.filteredListItems = [];
    this.filteredListItems = this.listItems.filter(val => {
      return val[this.optionLabelField].toString().toLowerCase().indexOf(value.toString().toLowerCase()) !== -1;
    });
    if (this.filterDropdownType === 1) {
      this.insertInListItems(value);
    }
  }

  ngOnInit(): void {
    this.filteredListItems = this.listItems;
    this.fixedValues = this.listItems.map((item) => item.value);

    this.contentChangeSubject.pipe(debounceTime(300)).subscribe(event => {
      if (!this.dynamicSearch) {
        this.filterList(event);
      }
      this.inputChangeEvent.emit(event)
    });
    this.toggleSubject.pipe(debounceTime(200)).subscribe(event => {
      this.toggleOptions(event);
    });
    this.removeDuplicateListValues(this.listItems);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.removeDuplicateListValues(this.listItems);
  }

  toggleChange(value) {
    this.toggleSubject.next(value);
  }

  insertInListItems(value) {
    const newValue = { [this.optionLabelField]: value, [this.optionValueField]: value }
    this.listItems = this.listItems.filter((item) => this.fixedValues.includes(item.value));
    if (!this.listItems.includes(newValue)) {
      this.listItems.unshift(newValue);
      this.removeDuplicateListValues(this.listItems);
      this.value = newValue;
    }
  }

  inputContentChange(value) {
    if (!value.trim() && !this.allowEmptySearch) return;
    this.contentChangeSubject.next(value);
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top - 10 >= 0 &&
      // rect.left - 10 >= 0 &&
      rect.bottom + 200 <= (window.innerHeight || document.documentElement.clientHeight)
      // rect.right + 200 <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  setValue(val) {
    // if Premium access then don't set in beaconstac-filter-dropdown but send the value for use in dashboard
    if (!val.isPremium){
      this.value = val;
    }
    this.valueChange.emit(val);
    if (this.specificOutput) {
      this.specificOutputChange.emit(val[this.specificOutput]);
    }
  }

  getMoreData(event) {
    this.fetchMoreData.emit();
  }

  removeDuplicateListValues(list: Array<any>) {
    this.filteredListItems = [...new Map(list.map((result) => [result[this.optionValueField], result])).values()];
  }

  handleStickCTAClick(event: any) {
    this.stickyCTAClicked.emit(event);
  }
}
